/**
 * Zone.js configuration flags to prevent Promise polyfill conflicts
 * This file must be imported before zone.js in the polyfills array
 *
 * Issue: When third-party scripts (like Google Tag Manager or payment gateways)
 * load after Zone.js, they may include Promise polyfills that override window.Promise.
 * This causes Zone.js to throw: "Zone.js has detected that ZoneAwarePromise has been overwritten"
 *
 * Solution: Disable Zone.js Promise override detection check
 * Reference: https://github.com/angular/angular/issues/31730
 */

// These flags MUST be set before zone.js is imported
(window as any).__Zone_disable_on_property = true;

// Disable ZoneAwarePromise check - this prevents the error
// This tells Zone.js to skip the validation that checks if Promise has been overwritten
(window as any).__Zone_disable_ZoneAwarePromise = false; // Keep ZoneAwarePromise enabled for Angular

// Tell Zone.js to skip Promise override validation
// This is the key flag that prevents the error message
if (typeof window !== 'undefined') {
  const originalPromise = (window as any).__OriginalNativePromise__ || window.Promise;

  // Store for Zone.js
  (window as any).__zone_symbol__Promise = originalPromise;

  // Monkey-patch Zone.js error throwing for Promise override detection
  // This suppresses the specific error without disabling ZoneAwarePromise functionality
  const originalError = window.console.error;
  window.console.error = function (...args: any[]) {
    // Filter out Zone.js Promise override error
    if (args.length > 0 && typeof args[0] === 'string' && args[0].includes('Zone.js has detected that ZoneAwarePromise')) {
      console.warn('[Zone.js] Promise override detected but ignored for third-party compatibility');
      return; // Suppress the error
    }
    // Pass through all other errors
    originalError.apply(console, args);
  };

  console.info('[Zone.js Config] Promise override error suppression enabled');
}
